var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"web-content",attrs:{"id":_vm.id}},[_c('iframe',{attrs:{"src":_vm.url,"allow":"fullscreen; clipboard-write"}})])}
var staticRenderFns = []

export { render, staticRenderFns }